const EHS_DESIGN_TABNAME = {
  EKB: 'EKB',
  EKB_FAV: 'EKB-Favourite',
}

const EHS_FEATURE_ENABLED = 1
const DEVICE_ORIENTATION = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
}

const ENTERPRISE_HOME_SCREEN_DESIGNER_ROUTES = {
  HOME: `/app/EnterpriseHomeScreenDesigner`,
  EDITOR: `/app/EnterpriseHomeScreenDesigner/editor`,
}
const ENTERPRISE_HOME_SCREEN = {
  KEY: 'enterpriseHomeScreen',
  TITLE: 'Enterprise Home Screen',
  DESCRIPTION:
    'Zebra-built Enterprise Home Screen provides a simple way for administrators to control access to apps and settings on a Zebra device without the need to write custom code',
}

const EHS_DESIGN_STUDIO = {
  TITLE: 'Design Studio for Enterprise Homescreen',
  DESCRIPTION:
    'Design custom homescreens for your workforce to improve task management and efficiency. Unlicensed users can create up to five custom homescreen designs.',
  BUTTON_TITLE: 'New Design',
  SINGLE_PROFILE_BUTTON_TITLE: 'Single Profile',
  ROLE_BASED_PROFILE_BUTTON_TITLE: 'Role Based Profile (for Identity Guardian)'
}

const EHS_DESIGN_STUDIO_FORM = {
  DESIGN_NAME: 'Design Name',
  DESIGN_DESCRIPTION: 'Design Description',
  DEVICE_TYPE: 'Device Type',
  DEVICE_TYPE_HELP_TEXT: `Once you have selected a device type, you won't be able to change it afterwards`,
  ORIENTATION: 'Orientation',
  ORIENTATION_HELP_TEXT: 'Orientation of Enterprise Homescreens is locked on end device.',
  VEHICLE_MOUNT_OPTION: 'Which vehicle mount is it?',
  WEARABLE_OPTION: 'Which wearable is it?',
}

const EHS_DESIGN_STATUS = {
  DRAFT: 'Draft',
  COMPLETE: 'Complete',
}

const DELETE_POP_CONFIRM = {
  TITLE: 'Are you sure?',
  DESCRIPTION: 'This cannot be undone.'
}

const BULK_DELETE_POP_CONFIRM = {
  TITLE: 'Are you sure you want to delete these designs?',
  DESCRIPTION: 'This can not be undone.'
}

const FOOTER_BUTTONS = {
  CLEAR_ALL: 'Clear All',
  BULK_DELETE: 'Delete'
}

const MARK_AS_COMPLETE_CONFIRMATION = {
  CONFIRM_TEXT: "Mark As Completed",
  BUTTON_TEXT: "Mark As Completed",
  CANCEL_TEXT: "Continue Editing",
  MARK_AS_COMPLETE_TITLE: "Are you sure you want to mark this design as complete?",
  MARK_AS_COMPLETE_MESSAGE: "Marking the design as 'completed' will prevent you from further editing",
  NO_ACTION_WARNING: " There are no application added, are you sure you want to continue?"
}

const PROFILE_NAME_ERRORS = {
  PROFILE_NAME_REQUIRED: "Please add design name it's mandatory to add",
  NAME_SHOULD_NOT_CONTAIN_SPACES: ' Name should not contain blank Spaces',
  DUPLICATE_PROFILE_NAME: ' File with this name already exists'
}

const DEVICE_TYPE_LIST = [
  { label: 'Show All', value: '' },
  { label: 'All Mobile', value: 'mobile' },
  { label: 'All Tablet', value: 'tablet' },
  { label: 'All Wearable', value: 'wearable' },
  { label: 'All Vehicle Mount', value: 'vehicleMount' },
]

const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  VEHICLE_MOUNT: 'vehicleMount',
  WEARABLE: 'wearable',
}

const DEFAULT_DEVICE_SUBTYPE = {
  vehicleMount: 'vc8300_8',
  wearable: 'wt6000'
}

const DEVICE_SUB_TYPES = {
  
}

const TABLE_TYPE = {
  ALL: 'allDesigns',
  FAVORITE: 'favoriteDesigns',
}

const EHS_DESIGN_ACTIONS = {
  EDIT: 'edit',
  VIEW: 'view',
  DELETE: 'delete',
  DUPLICATE: 'duplicate',
  EXPORT: 'export',
  DEPLOY: 'deploy',
}

const EHS_DESIGN_PROFILE_TYPE = {
  SINGLE_PROFILE: 'singleProfile',
  ROLE_BASED_PROFILE: 'roleBasedProfile',
}

const EHS_ROLE_CREATION_TYPE = {
  BROWSE_ROLE: 'browseRole',
  CREATE_NEW_ROLE: 'createNewRole',
}
const MAX_ROLE_NUMBER = 10  
module.exports = {
  EHS_DESIGN_TABNAME,
  EHS_FEATURE_ENABLED,
  DEVICE_ORIENTATION,
  ENTERPRISE_HOME_SCREEN_DESIGNER_ROUTES,
  ENTERPRISE_HOME_SCREEN,
  EHS_DESIGN_STUDIO,
  EHS_DESIGN_STUDIO_FORM,
  EHS_DESIGN_STATUS,
  DELETE_POP_CONFIRM,
  BULK_DELETE_POP_CONFIRM,
  FOOTER_BUTTONS,
  MARK_AS_COMPLETE_CONFIRMATION,
  PROFILE_NAME_ERRORS,
  DEVICE_TYPE_LIST,
  DEVICE_TYPES,
  DEFAULT_DEVICE_SUBTYPE,
  TABLE_TYPE,
  EHS_DESIGN_ACTIONS,
  EHS_DESIGN_PROFILE_TYPE,
  EHS_ROLE_CREATION_TYPE,
  MAX_ROLE_NUMBER
}
